import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global 402 (Payment Required) handler — broadcast an event any page can listen to
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      const detail = err.response.data?.detail || "This feature requires a paid plan.";
      window.dispatchEvent(new CustomEvent("sd:paywall", { detail: { message: detail } }));
    }
    return Promise.reject(err);
  }
);
